import type { CustomOptionValue } from "core/catalog";
import { cn } from "core/shared";
import { price } from "~/modules/shared/utils";

type OptionValueRowProps = {
  value: CustomOptionValue;
};

export function OptionValueRow({ value }: OptionValueRowProps) {
  const hasPrice = !!value.price && value.price !== 0;

  const priceBadge = hasPrice ? (
    <span className={cn("text-primary-default min-w-11 text-sm font-bold")}>
      ({value.priceType === "add" ? "+" : "-"} {price(value.price)})
    </span>
  ) : null;

  const visual = value.image ? (
    <img
      src={value.image}
      alt={value.name}
      className="aspect-square size-6 rounded object-cover"
    />
  ) : value.color ? (
    <span
      className="size-5 rounded-full border"
      style={{ backgroundColor: value.color }}
    />
  ) : null;

  return (
    <div className="flex items-start justify-between gap-2">
      <div className="flex items-center gap-2">
        {visual}
        <span>{value.name}</span>
      </div>
      {priceBadge}
    </div>
  );
}
